import {useDispatch, useSelector} from "react-redux";
import {select} from "application/store";
import {useCallback, useEffect} from "react";
import {useParams} from "react-router-dom";

export const useDocumentDetail = () => {
  const dispatch = useDispatch();
  const {id} = useParams();

  const state = useSelector(
    select((models) => ({
      documents: models.documentDetail.documents,
      isLoading: models.documentDetail.isLoading,
      detailInfo: models.documentDetail.detailInfo,
      isError: models.documentDetail.isError,
      errorMessage: models.documentDetail.errorMessage,
    }))
  );

  const onDownloadDocuments = useCallback(() => {
    dispatch.documentDetail.downloadComponentsAction();
  }, []);

  useEffect(() => {
    if (!id) return;
    dispatch.documentDetail.loadDocumentDetailAction(id);
  }, [id]);

  return {...state, onDownloadDocuments};
};

